import React, { useState } from 'react';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ExitToApp from '@material-ui/icons/ExitToApp';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { ReactComponent as Logo } from '../../static/opms_logo.svg';
import { Button } from '@material-ui/core';
import { useAppContext } from 'containers/app-context/app-context.container';

type HeaderProps = {
	py: number;
	width: string | number;
};

export const Header = ({ py, width }: HeaderProps): React.FunctionComponentElement<HeaderProps> => {
	const { context } = useAppContext();
	const { clearContext, isLoggedIn } = context;
	const [confirmationOpen, setConfirmationOpen] = useState(false);

	const handleSignOutClick = () => {
		setConfirmationOpen(true);
	};

	const handleConfirmSignOut = () => {
		setConfirmationOpen(false);
		// Reset the url
		const url = new URL(window.location.href);
		url.searchParams.delete('authorization_code');
		window.location.href = url.toString();
		clearContext?.();
	};

	const handleCancelSignOut = () => {
		setConfirmationOpen(false);
	};

	return (
		<Box>
			{isLoggedIn && (
				<Box display="flex" justifyContent="right" alignItems="center">
					<Button color="primary" startIcon={<ExitToApp />} onClick={handleSignOutClick}>
						Log Out
					</Button>
				</Box>
			)}
			<Box display="flex" width={width} py={py}>
				<Grid container item direction="column" justify="center" alignItems="center">
					<Grid item>
						<Logo width="180" />
					</Grid>
					<Grid item>
						<Typography variant="h4">OPMS Sign On</Typography>
					</Grid>
				</Grid>
			</Box>
			<Dialog open={confirmationOpen} onClose={handleCancelSignOut}>
				<DialogTitle>Confirm Log Out</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Are you sure you want to log out? This will reset the Sign On application.
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCancelSignOut} color="primary">
						Cancel
					</Button>
					<Button onClick={handleConfirmSignOut} color="primary" autoFocus>
						Log Out
					</Button>
				</DialogActions>
			</Dialog>
		</Box>
	);
};
